import React from 'react'
import './Style/foooter.css'
function Footer() {
  return <div class="footer">
  <div class="footer-conditions">
      <div class="conditions">
          <h3> Terms & Conditions</h3>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. </p>
      </div>
      <div class="sign">
          <h3> Authorised Sign</h3>
      </div>
  </div>
  <p class="thank"> Thank you for your business</p>
</div>
}

export default Footer